import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TestimonialFormLayer from "../components/TestimonialFormLayer";

const TestimonialFormPage = () => {
    return (
        <MasterLayout>
            <TestimonialFormLayer />
        </MasterLayout>
    );
};

export default TestimonialFormPage;
